import React, { useState } from "react";
import { Tabs } from "antd";
import BaggingAutomate from "./baggingAutomate";
import { useSearchParams, useNavigate } from "react-router-dom";
// import Heading from "../../../components/Heading";
// import lcr_white from "../../../assests/images/SVG/lcr-white.svg";
import BaggingAndShipment from "../LCRGeneration/BaggingAndShipment";

const baggingTab = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const tabFromUrl = searchParams.get("tab") || "1";
  const [step, setStep] = useState(tabFromUrl);
  
  const onChange = (key) => {
    setStep(key);
    navigate(window.location.pathname + "?tab=" + key, { replace: true, state: undefined });
  };
  const items = [
    {
      key: "1",
      label: "Bag Finalization",
      children: <BaggingAutomate />,
    },
    {
      key: "2",
      label: "Eligible Bags & Shipments",
      children: <BaggingAndShipment />,
    },
  ];
  return (
    <div className="p-2">
      {/* <Heading
        title={"Bagging"}
        nextPage={"/create-or-update-trip"}
        nextPageTitle={"LCR GENERATION"}
        imgSrc={lcr_white}
      /> */}
      <Tabs
        destroyInactiveTabPane
        defaultActiveKey={tabFromUrl}
        activeKey={step}
        items={items}
        onChange={onChange}
        style={{ marginTop: "-1.5rem" }}
      />
    </div>
  );
};

export default baggingTab;
